import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://bpdywqqjpmknogmjahhk.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJwZHl3cXFqcG1rbm9nbWphaGhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU0ODY0NTYsImV4cCI6MjA5MTA2MjQ1Nn0.lNPK1I1x4kn5EB0P0x8fYXLYCai4waYwNhI_MumKJlE';

// Create Supabase client with realtime configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  global: {
    fetch: (url, options = {}) => {
      // Use native fetch and prevent any middleware from cloning the response
      return fetch(url, options);
    }
  }
});
